import { useMutation, useQueryClient } from '@tanstack/react-query';
import { 
  loginMutation, 
  refreshTokenMutation, 
  logoutMutation 
} from '@/shared/api/generated/@tanstack/react-query.gen';
import type { 
  LoginData, 
  LoginResponse2,
  RefreshTokenData,
  RefreshTokenResponse2,
  LogoutData
} from '@/shared/api/generated/types.gen';

export const authQueries = {
  login: () => ({
    mutationKey: ['auth', 'login'],
    ...loginMutation(),
  }),
  
  refreshToken: () => ({
    mutationKey: ['auth', 'refresh'],
    ...refreshTokenMutation(),
  }),
  
  logout: () => ({
    mutationKey: ['auth', 'logout'], 
    ...logoutMutation(),
  }),
};

export const useLogin = () => {
  return useMutation(authQueries.login());
};

export const useRefreshToken = () => {
  return useMutation(authQueries.refreshToken());
};

export const useLogout = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    ...authQueries.logout(),
    onSuccess: () => {
      queryClient.clear();
    },
  });
};